import UserModel from "../models/UserModel";

export const base_url = "http://localhost:8000/api/v1/";
// ✅ Créer un abonnement récurrent
export async function createSubscription(planId, billing, token) {
  const apiUrl = `${base_url}paiement/createsubscription`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      plan: planId,       // correspond à 'basic', 'pro', 'business'
      interval: billing   // 'monthly' ou 'yearly'
    })

  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: "Erreur serveur" }));
    throw new Error(err.message || "Erreur création abonnement");
  }

  return response.json(); // { success, subscription_id, client_secret }
}
// ✅ Annuler un abonnement
export async function cancelSubscription(token) {
  const apiUrl = `${base_url}paiement/cancelsubscription`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: "Erreur serveur" }));
    throw new Error(err.message || "Erreur annulation abonnement");
  }

  return response.json(); // { success, message }
}
export async function reactivateSubscription(token) {
  const apiUrl = `${base_url}paiement/reactivatesubscription`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: "Erreur serveur" }));
    throw new Error(err.message || "Erreur annulation abonnement");
  }

  return response.json(); // { success, message }
}
// ✅ Abonnement gratuit (plan 0€)
export async function freeSubscribe(plan, billing, token) {
  const apiUrl = `${base_url}paiement/free-subscribe`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ plan, billing }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: "Erreur serveur" }));
    throw new Error(err.message || "Erreur abonnement gratuit");
  }

  return response.json();
}
export async function createPaymentIntent(amount, plan, billing, token) {
  const apiUrl = `${base_url}paiement/create-intent`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ price: amount, plan, billing }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Erreur serveur' }));
    throw new Error(err.message || 'Erreur création PaymentIntent');
  }

  return response.json(); // { success, client_secret, payment_intent_id, ... }
}
export async function confirmCheckoutSessionOnServer(sessionId, token) {
  const apiUrl = `${base_url}paiement/confirm`; // nouvel endpoint backend

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({ message: 'Erreur serveur' }));
      throw new Error(err.message || 'Erreur confirmation Checkout Session');
    }

    const data = await response.json();
    console.log("Réponse backend confirmCheckoutSession:", data);
    return data;
  } catch (error) {
    console.error("Erreur confirmCheckoutSessionOnServer:", error.message);
    throw error;
  }
}
function getAuthHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}
export async function tvainfo(token) {
  try {
    const response = await fetch(`${base_url}tvainfo`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute TVA Info:", text);

    const data = JSON.parse(text); // transforme en JSON
    if (!response.ok || !data.success) {
      console.error("Erreur TVA Info:", data);
      return { success: false, message: data.message || "Erreur récupération TVA info" };
    }

    // Renvoie uniquement les infos TVA
    return {
      success: true,
      tva_inclus: data.tva_inclus,
      tva_rates: data.tva_rates
    };
  } catch (error) {
    console.error("Catch TVA Info:", error);
    return { success: false, message: error.message };
  }
}

export async function ProfilInfo(token) {
  try {
    const response = await fetch(`${base_url}dashboard`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute Me:", text);

    const data = JSON.parse(text); // transforme en JSON

    if (!response.ok || !data.success) {
      console.error("Erreur Me:", data);
      return { success: false, message: data.message || "Erreur récupération profil" };
    }

    // Instancie le modèle UserModel pour gérer nulls et paiements
    const user = new UserModel({ ...data.user, paiements: data.paiements, comptable_status: data.comptable_status });

    return { success: true, user };
  } catch (error) {
    console.error("Catch Me:", error);
    return { success: false, message: error.message };
  }
}
export async function Me(token) {
  try {
    const response = await fetch(`${base_url}me`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute Me:", text);

    const data = JSON.parse(text); // transforme en JSON
    if (!response.ok || !data.success) {
      console.error("Erreur Me:", data);
      return { success: false, message: data.message || "Erreur récupération profil" };
    }

    return { success: true, user: data.user };
  } catch (error) {
    console.error("Catch Me:", error);
    return { success: false, message: error.message };
  }
}
// ✅ Se déconnecter
export async function Logout(token) {
  try {
    const response = await fetch(`${base_url}logout`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const data = await response.json();
    if (!response.ok) throw new Error("Erreur déconnexion");

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

// ✅ Rafraîchir le token
export async function Refresh(token) {
  try {
    const response = await fetch(`${base_url}refresh`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur refresh" };
    }

    return { success: true, token: data.token };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
export async function UpdateProfile(token, formData) {
  if (!token) throw new Error("Utilisateur non authentifié");

  console.log("Objet reçu (avant envoi) :", formData);

  try {
    const response = await fetch(`${base_url}updateprofile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    let data;
    try {
      data = await response.json();
    } catch (err) {
      console.error("Erreur parsing JSON :", err);
      throw new Error("Le serveur a renvoyé une réponse invalide");
    }

    if (!response.ok || !data.success) {
      const message = data?.message || "Erreur mise à jour profil";
      return { success: false, message };
    }

    // ⚡ Instanciation du modèle UserModel
    const user = new UserModel(data.user);

    return { success: true, user, message: data.message };
  } catch (error) {
    console.error("Erreur fetch UpdateProfile :", error);
    return { success: false, message: error.message };
  }
}
// ✅ Modifier le mot de passe
export async function UpdatePassword(token, ancienPassword, newPassword) {
  try {
    const response = await fetch(`${base_url}updatePassword`, {
      method: "POST",
      headers: getAuthHeaders(token),
      body: JSON.stringify({ ancienPassword, newPassword }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur mise à jour mot de passe" };
    }

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
// ✅ Modifier le mot de passe
export async function Updaterib(token, rib) {
  try {
    const response = await fetch(`${base_url}updateinfo`, {
      method: "POST",
      headers: getAuthHeaders(token),
      body: JSON.stringify({ rib }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur mise à jour mot de passe" };
    }

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
// ✅ Changer l'image de profil (multipart/form-data)
export async function ChangeImage(token, file) {
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${base_url}changeimage`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, // pas de content-type, sinon form-data cassé
      },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur changement d'image" };
    }

    return { success: true, imageUrl: data.imageUrl };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
export async function Login(email, password) {
  const apiUrl = `${base_url}login`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const responseData = await response.json();

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || "Échec de la connexion.",
      };
    }

    console.log("token insid Login", responseData.token);

    return {
      success: true,
      token: responseData.token,
      utilisateur: responseData.utilisateur, // 👈 ajoute ton utilisateur
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de la connexion.",
    };
  }
}
export async function register(nom_complet, email, siret, password, telephone, code_promo_utilise = null) {
  const apiUrl = `${base_url}register`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nom_complet,
        email,
        siret,
        password,
        telephone,            // ✅ nouveau champ obligatoire
        code_promo_utilise,   // ✅ facultatif
      }),
    });

    const responseData = await response.json();
    console.log("Response from Register Service:", responseData);

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || "Échec de l'inscription.",
      };
    }

    return {
      success: true,
      message: responseData.message || "Inscription réussie ✅",
      token: responseData.token,
      utilisateur: responseData.utilisateur,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de l'inscription.",
    };
  }
}

// ✅ Récupérer les statistiques avec filtre par dates
export async function getStatistics(token, dateDebut = null, dateFin = null) {
  try {
    const response = await fetch(`${base_url}getstatistics`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        date_debut: dateDebut,
        date_fin: dateFin,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return {
        success: false,
        message: data.message || "Erreur récupération statistiques",
      };
    }

    // 🔹 Retourne directement l'objet complet
    return { success: true, tva_inclus: data.tva_inclus, statistiques: data.statistiques };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function tvaMensuelle(token, dateDebut, dateFin) {
  try {
    const response = await fetch(`${base_url}tvamensuelle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        date_debut: dateDebut,
        date_fin: dateFin,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération TVA" };
    }

    return {
      success: true,
      tva_par_taux: data.tva_par_taux || {},
      tva_user: data.tva_user || {},
      totaux_tva: data.totaux_tva || 0,
    };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

// Récupérer les revenus par mois pour une année donnée
export async function getRevenusParMois(token, year) {
  try {
    const response = await fetch(`${base_url}revenusparmois`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ year }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération revenus" };
    }

    return { success: true, revenus: data.revenus };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
// Récupérer les revenus par mois pour une année donnée
export async function getCamembert(token) {
  try {
    const response = await fetch(`${base_url}camembert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération revenus" };
    }

    // renvoie exactement les clés que ton front attend
    return {
      success: true,
      revenu_batiment: data.revenu_batiment || {},
      revenu_autres: data.revenu_autres || {},
    };
  } catch (error) {
    return { success: false, message: "Erreur: Actualiser la page" };
  }
}

// ✅ Récupérer l'abonnement de l'utilisateur
export async function getAbonnement(token) {
  try {
    const response = await fetch(`${base_url}abonnement`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération abonnement" };
    }

    return { success: true, abonnement: data.abonnement };
  } catch (error) {
    return { success: false, message: error.message };
  }
}


//Comptable
// Envoi invitation
export async function envoyercomptable(email_comptable, token) {
  const apiUrl = `${base_url}envoyercomptable`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email_comptable }),
    });
    const responseData = await response.json();
    if (!response.ok || !responseData.success) {
      return { success: false, message: responseData.message || "Échec de l'envoi de l'invitation." };
    }
    return { success: true, message: responseData.message || "Invitation envoyée avec succès." };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue lors de l'envoi." };
  }
}

// Vérifier invitation via code
export async function checkInvitationComptable(email, code) {
  const apiUrl = `${base_url}check-invitation`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email_comptable: email, code }),
    });

    // Vérifie si la réponse contient du JSON
    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      return { success: false, message: `Erreur serveur inattendue (status ${response.status})` };
    }

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Invitation invalide" };
    }

    return {
      success: true,
      needs_password: data.needs_password,
      email_comptable: data.email_comptable
    };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue" };
  }
}



// Définir mot de passe après invitation
export async function setPasswordComptable(email, code, password, password_confirmation) {
  const apiUrl = `${base_url}set-password`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email_comptable: email, code, password, password_confirmation }),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur lors de la définition du mot de passe" };
    }
    return { success: true };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue" };
  }
}


// Login comptable
export async function loginComptable(email, password, code) {
  const apiUrl = `${base_url}logincomptable`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email_comptable: email,
        password_comptable: password,
        code: code, // ⚠️ Ajout du code d'invitation
      }),
    });

    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      return { success: false, message: `Erreur serveur inattendue (status ${response.status})` };
    }

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Échec de la connexion" };
    }

    return { success: true, token: data.token, user: data.utilisateur };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue" };
  }
}
export async function infoComptable(token) {
  const apiUrl = `${base_url}infocomptable`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      return { success: false, message: `Erreur serveur inattendue (status ${response.status})` };
    }

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Échec de la récupération des informations" };
    }

    // Ici on retourne exactement la structure que tu veux
    return {
      success: true,
      user: {
        id: data.user.id,
        nom_complet: data.user.nom_complet,
        email: data.user.email,
        nom_commercial: data.user.nom_commercial,
        capital: data.user.capital,
        forme_juridique: data.user.forme_juridique,
        tva_inclus: data.user.tva_inclus,
        tva_rates: data.user.tva_rates,
        siret: data.user.siret,
        numero_tva: data.user.numero_tva,
        adresse_ligne1: data.user.adresse_ligne1,
        adresse_ligne2: data.user.adresse_ligne2,
        code_postal: data.user.code_postal,
        ville: data.user.ville,
        code_pays: data.user.code_pays,
        telephone: data.user.telephone,
        devise: data.user.devise,
        created_at: data.user.created_at,
        updated_at: data.user.updated_at,
      },
    };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue" };
  }
}


// Vérifier si le comptable est connecté (token valide)
export async function isConnectedComptable(token) {
  const apiUrl = `${base_url}is-connected-comptable`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Comptable non connecté" };
    }
    return { success: true, user: data.user };
  } catch (error) {
    return { success: false, message: error.message || "Erreur inattendue" };
  }
}

// Contact
export async function contact(formData, token = null) {
  const apiUrl = `${base_url}contact`; // Assure-toi que la route correspond à Laravel

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }), // si tu veux authentifier l'utilisateur
      },
      body: JSON.stringify(formData),
    });

    const responseData = await response.json();

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || responseData.error || "Échec de l'envoi du message.",
      };
    }

    return {
      success: true,
      message: responseData.message || "Message envoyé avec succès !",
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de l'envoi du message.",
    };
  }
}



